import { LOGO_ICON } from "../../assets/icons";
import { Link } from "react-router-dom";

export function LogoButton() {
  return (
    <Link
      to="/dashboard"
      className="relative flex items-center justify-center h-12
                 transition-all duration-200
                 hover:scale-[1.03] focus:outline-none w-[150px]"
    >
      <div className="w-[135px] h-full flex items-center justify-center p-4">
        {LOGO_ICON}
      </div>
    </Link>
  );
}